function idValidator(obj) {
    const provinces = {
        11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古",
        21: "辽宁", 22: "吉林", 23: "黑龙江", 31: "上海", 32: "江苏",
        33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南",
        42: "湖北", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆",
        51: "四川", 52: "贵州", 53: "云南", 54: "西藏", 61: "陕西", 62: "甘肃",
        63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外"
    };
}

export function checkIdCard(idcard) {
    const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!regIdCard.test(idcard)) {
        // errorMsg = '身份证号填写有误';
        return false;
    } else {
        return true;
    }
}

export function getBirthdayAndSex(idCard) {
    let info = {};
    let birth = birth = (idCard.length === 18) ? idCard.slice(6, 14) : idCard.slice(6, 12);
    console.log(birth)

    info.birthDay = (idCard.length === 18) ? ([birth.slice(0, 4),
        birth.slice(4, 6), birth.slice(-2)
    ]).join('-') : ([
        '19' + birth.slice(0, 2), birth.slice(2, 4),
        birth.slice(-2)
    ]).join('-');

    let order = (idCard.length === 18) ? idCard.slice(-2, -1) : idCard.slice(-1);
    console.log(order)
    info.sex = (order % 2 === 0 ? 0 : 1);// 余数为0代表女性，不为0代表男性
    return info;
}


